// extracted by mini-css-extract-plugin
module.exports = {"title":"Confirmation_title__zZtWY"};